import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed } from 'knockout';
import { CurrentUserManager } from 'managers/currentUser';
import { IWCCStorageManager } from 'managers/iStorage';

export interface DiscussionTranslationManagerConfig {
    discussionId: string
}

@injectable()
export default class DiscussionTranslationManager {
    isAllowed: PureComputed<boolean>
    isAllowedToShow = ko.pureComputed(() => this.isAllowed() && settings.ui.isTranslationShown())

    constructor(
        @inject(wccModules.managerConfig) { discussionId }: DiscussionTranslationManagerConfig,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        const userManager = storage.get(CurrentUserManager, { discussionId });
        const user = userManager.pluck('person');
        const isModeratorOrObserver = user.pluck('isModeratorOrObserver', false);

        this.isAllowed = ko.pureComputed(() => settings.translationLanguage != undefined && isModeratorOrObserver());
    }
}